/*ěščřžýáíéúů*/

// SwiperJS pro posts slider
function initKnowUsSwiper() {
    const postsSwiper = new Swiper(".know-us__slider-swiper", {
        slidesPerView: "auto",
        spaceBetween: 64,
        loop: true,
        freeMode: true,
        navigation: {
            nextEl: ".buttons-know-us__next",
            prevEl: ".buttons-know-us__prev",
        },
    });
}

// Inicializuj KnowUs swiper
if (document.querySelector(".know-us__slider-swiper")) {
    initKnowUsSwiper();
}
